import React from 'react'

let placeholder = 'Type your question here...'

export default React.createClass({

  getInitialState: function() {
    return {
      question: '',
    }
  },
  onSearchChange () {
    if (document.getElementById('searchBar').value !== '') {
      document.getElementById('searchLabel').innerHTML = ''
      this.render()
    } else {
      document.getElementById('searchLabel').innerHTML = placeholder
    }
  },
  handleMessageChange: function (event) {
    const target = event.target;
    this.setState({question: target.value});
  },

  render: function () {
    return (
      <form className='form-inline'>
        <div className='form-group is-search' style={{margin: '20px auto'}}>
          <label htmlFor='searchBar ' className='baseline-color'>
            <i style={{marginLeft: 10, marginRight: 10}}className='fa fa-search' />
          </label>
          <label id='searchLabel' htmlFor='searchBar' className='baseline-color' style={{margin: '0 50px', fontWeight: 300}}>
            {placeholder}
          </label>
          <input type='search' className='form-control' id='searchBar' onChange={this.handleMessageChange} style={{width: '90%', backgroundColor: 'white'}} />
        </div>
        <button type='submit' className='btn btn-sm btn-success hidden-xs' style={{marginLeft: 20}} onClick={() => this.props.search(this.state.question)}>Search</button>
      </form>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/support/searchbar.jsx